import { API_PATH } from "@/common/constant";
import ApiService from "@/common/api.service";

export const GET_ROLE = () => ApiService.get(API_PATH.GET_ROLE, "");

export const LOGIN = (params) => ApiService.post(API_PATH.LOGIN, { ...params });

export const LOGOUT = () => ApiService.get(API_PATH.LOGOUT);
